import { Inject, ModelEvents, Singleton } from '@denishussar/html5-game-engine';
import { AchievementType } from '../../../../../Models/Game/AchievementModel';
import { GameModel } from '../../../../../Models/Game/GameModel';
import { LoanAvatarEnum, LoanModel, LoanThingsEnum } from '../Models/LoanModel';

@Singleton
export class LoanLogic {
    constructor(
        @Inject private _model: LoanModel,
        @Inject private _gameModel: GameModel,
        @Inject private _modelEvents: ModelEvents,
    ) {
    }

    private _counterRightAnswers: number = 0;

    public reset(): void {
        this._counterRightAnswers = 0;

        this._model.buttons = ['approve', 'refuse'];
        this._model.things = LoanThingsEnum.phone;
        this._model.avatars = LoanAvatarEnum.blonde;
        this._model.name = 'purple';
    }

    public getRandomCredit(): void {
        this._model.avatars = this._getRandomProp(LoanAvatarEnum);
        this._model.things = this._getRandomProp(LoanThingsEnum);
    }

    public startAction(action: string | boolean) {
        this._counterRightAnswers++
        if (action === 'approve' && this._model.avatars === 'baby') {
            this.getRandomCredit()
            return false;
        } else if (action === 'refuse' && this._model.avatars === 'baby') {
            this.getRandomCredit()
            return true;
        } else if (action === 'refuse') {
            this.getRandomCredit()
            return false;
        } else {
            this.getRandomCredit()
            return true;
        }
    }

    public isWin(): boolean {
        return this._counterRightAnswers >= 3;
    }

    private _getRandomProp(obj: object) {
        const keys = Object.keys(obj);

        return obj[keys[(keys.length * Math.random()) << 0]];
    }
}
